import React from 'react';
import { CheckIcon } from '../lib/icons';
import { useReveal } from '../lib/useReveal';
const HOTMART = 'https://pay.hotmart.com/O103704589E';
const FEATURES = ['6 Tomos de Reiki', '3 Bonos exclusivos', 'Acceso inmediato', 'Descarga digital', 'Acceso de por vida'];
export function PricingSection() {
  const [ref1, vis1] = useReveal();
  return <section id="pricing" className="bg-[#2d1f3d] text-white py-20 md:py-28 px-4" data-id="element-264">
      <div className="container mx-auto max-w-2xl" data-id="element-265">
        <div ref={ref1} className={`reveal-scale bg-gray-800/50 rounded-3xl p-6 sm:p-8 md:p-12 border border-gray-700 text-center ${vis1 ? 'is-visible' : ''}`} data-id="element-266">
          <h2 className="text-2xl sm:text-3xl md:text-5xl font-serif font-bold mb-8 md:mb-10" data-id="element-267">
            📦 Lo que recibís hoy
          </h2>

          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 max-w-md mx-auto mb-10 md:mb-12" data-id="element-268">
            {FEATURES.map((feature, idx) => <div key={idx} className="flex items-center gap-3 text-left" data-id="element-269">
                <div className="bg-green-500/20 p-1 rounded-full flex-shrink-0" data-id="element-270">
                  <CheckIcon className="w-4 h-4 text-green-400" strokeWidth={3} data-id="element-271" />
                </div>
                <span className="text-gray-300 font-medium text-sm sm:text-base" data-id="element-272">
                  {feature}
                </span>
              </div>)}
          </div>

          <div className="mb-8 md:mb-10" data-id="element-273">
            <p className="text-gray-500 text-sm sm:text-base line-through decoration-red-500 decoration-2 mb-3" data-id="element-274">
              Precio regular: ARS $49.990
            </p>
            <p className="text-amber-400 font-bold text-base sm:text-lg mb-1" data-id="element-275">
              🔥 OFERTA SOLO POR HOY:
            </p>
            <p className="text-4xl sm:text-5xl md:text-7xl font-extrabold text-white leading-none mb-2" data-id="element-276">
              ARS $19.990
            </p>
            <p className="text-gray-500 text-xs sm:text-sm" data-id="element-277">
              (Pagás en tu moneda local)
            </p>
          </div>

          <a href={HOTMART} target="_blank" rel="noopener noreferrer" className="cta-btn inline-flex items-center justify-center gap-2 w-full sm:w-auto px-6 sm:px-10 py-4 sm:py-5 rounded-full text-white font-bold text-base sm:text-lg md:text-2xl tracking-widest uppercase transition-all" style={{
          fontFamily: "'Cormorant Garamond', serif",
          letterSpacing: '0.1em',
          background: 'linear-gradient(135deg, #1a6b3a 0%, #2d9a55 50%, #1a6b3a 100%)',
          boxShadow: '0 0 45px rgba(29,107,58,0.55), inset 0 1px 0 rgba(255,255,255,0.15)'
        }} data-id="element-278">
            🔥 ACCEDE AL CURSO HOY 👉
          </a>

          <div className="mt-6 border border-green-500/20 bg-green-500/5 rounded-2xl px-4 sm:px-6 py-4 sm:py-5 max-w-sm mx-auto text-center" data-id="element-279">
            <p className="text-green-400 font-bold text-xs sm:text-sm mb-1" data-id="element-280">
              🔒 Compra protegida por Mercado Pago
            </p>
            <p className="text-white font-semibold text-sm sm:text-base mb-2" data-id="element-281">
              Garantía sin riesgo
            </p>
            <p className="text-gray-400 text-xs sm:text-sm leading-relaxed" data-id="element-282">
              Probalo durante{' '}
              <span className="text-white font-bold" data-id="element-283">7 días</span>. Si sentís
              que no es para vos, te devolvemos el{' '}
              <span className="text-white font-bold" data-id="element-284">100% de tu dinero</span>.
              Sin preguntas. Sin culpa.
            </p>
          </div>
        </div>
      </div>
    </section>;
}